import React from "react";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 2rem;
  width: 555px;
  height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const CheckmarkIcon = styled.div`
  width: 106px;
  height: 106px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ConfirmationMessage = styled.h2`
  font-size: 30px;
  font-weight: 500;
  color: #323232;
  margin-bottom: 2rem;
  line-height: 1.2;
`;

const ConfirmButton = styled.button`
  background: #00B5B8;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  min-width: 120px;

  &:hover {
    background: #009A9D;
  }
`;

const EditTemplateConfirmationModal = ({ isOpen, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CheckmarkIcon>
          <img src="/check.png" alt="check" width="106" height="106" />
        </CheckmarkIcon>

        <ConfirmationMessage>
          ยืนยันการแก้ไข Template
        </ConfirmationMessage>

        <ConfirmButton onClick={onConfirm}>
          ยืนยัน
        </ConfirmButton>
      </ModalContent>
    </ModalOverlay>
  );
};

export default EditTemplateConfirmationModal;